import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchFeatureFlags } from '../../../reducers/featureFlagSlice';
import { useLelyAuth } from '../../../auth/useLelyAuth';

export default function useFeatureFlag(
  interceptorsStatus: 'initialized' | 'not-initialized',
) {
  const dispatch = useDispatch();
  const { user } = useLelyAuth();
  useEffect(() => {
    if (
      interceptorsStatus === 'initialized' &&
      user &&
      user.email &&
      user.allowltda
    ) {
      dispatch(fetchFeatureFlags());
    }
  }, [user, interceptorsStatus]);
}
